import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/LoadingTest.css';
import Label from '../components/atoms/Label';

const LoadingTest = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/test-instructions'); // Adjust this path based on your routing setup
    }, 2000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      justifyContent: 'center',
      minHeight: '80vh',
      gap: '20px'
    }}>
      <Label label="Starting your practice test" fontSize="31px" fontWeight="400" color="#5957FF" textAlign="left" margin="0px" padding="0px"/>
    
      <Label label="Please refresh this page if test does not start." fontSize="25px" fontWeight="400" color="#000000" textAlign="left" margin="0px" padding="0px"/>
      <div className="loading-spinner" style={{
        width: '50px',
        height: '50px',
        border: '4px solid #f3f3f3',
        borderTop: '4px solid #4B4BF5',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite'
      }} />
    </div>
  );
};

export default LoadingTest; 